<template>
  <div class="payments">
    <div class="d-flex flex-column mb-4">
      <v-tabs
        center-active
        slider-size="4"
        v-model="tab"
        class="border-bo"
      >
        <v-tab :ripple="false" href="#transactions" class="font font--h4 payments-tab-link">
          Начисления
        </v-tab>

        <v-tab :ripple="false" href="#pending_payments" class="font font--h4 payments-tab-link" v-show="hasPendingPayments">
          <v-badge
            bordered

            color="primary"
            :value="hasPendingPayments"
            :content="pending_payments.length"
          >
            Ожидающих к выплате
          </v-badge>
        </v-tab>

        <v-tab :ripple="false" href="#reports" class="font font--h4 payments-tab-link">
          Акты и отчёты
        </v-tab>
      </v-tabs>
      <v-spacer></v-spacer>
      <div class="align-self-end" v-if="tab === 'transactions'">
        <DateFilter @change="applyDateFilter" @change-date="setDateFilter" :value="dateFilter" />
        <v-btn class="btn-icon" outlined @click="statusFilterPayment = !statusFilterPayment">
          <v-badge dot overlap color="error" offset-x="8" bordered :value="hasStatusFilter">
            <v-icon class="mr-md-1">mdi-filter-outline</v-icon>
          </v-badge>

          <span class="d-none d-md-inline">Фильтры</span>
        </v-btn>
      </div>
    </div>

    <v-tabs-items v-model="tab" touchless>
      <v-tab-item value="transactions">
        <div class="d-flex" style="position: relative; left: 600px; bottom: 40px">
          <transition name="slide">
            <StatusFilter
              @input="applyStatusFilter"
              :value="statusFilter"
              :list="statusList"
              filterTitle="Статус оплаты"
              v-show="statusFilterPayment"
              v-click-outside="{
                handler: closeStatusFilter,
                closeConditional: shouldCloseFilter,
              }"
            />
          </transition>
        </div>
        <div class="payments__stat d-sm-flex mb-4 py-3 px-6">
          <div class="mr-sm-6">
            <span class="font--color_light">Заработано: </span>
            <span style="color: #6ca300">+{{ makeRub(sum_refill) }}</span>
          </div>
          <div>
            <span class="font--color_light">Выведено: </span>
            <span style="color: #bd2c2c">-{{ makeRub(sum_wo) }}</span>
          </div>
        </div>

        <v-alert
          v-if="hasPendingPayments"
          dense
          colored-border
          elevation="1"
          border="left"
          color="orange"
          type="info"
        >
          У Вас имеются
          <a @click.prevent.stop="tab = 'pending_payments'" class="text-decoration-none">
            выплаты которые ещё находятся в обработке
          </a>
          и могут быть обработаны позже
        </v-alert>

        <v-data-table
          :mobile-breakpoint="100"
          class="bidlist-table"
          :headers="dataTables.transactions.headers"
          :items="payments"
          item-key="id"
          :server-items-length="total"
          :options.sync="options"
          :footer-props="dataTables.transactions.footerProps"
          :no-data-text="dataTables.transactions.noDataText"
        >
          <template #top>
            <v-text-field
              dense
              single-line
              hide-details
              outlined
              v-model="search_query"
              label="Введите наименование операции"
              class="mb-4"
              clearable
            ></v-text-field>
          </template>

          <template #[`item.dadd`]="{ value }">
            <span>{{ new Date(value).toLocaleDateString() }}</span>
          </template>

          <template #[`item.reason`]="{ value, item }">
            <span>
              <span>{{ value }}</span
              ><br />
              <span class="font font--label-light font--color_light">{{ item.name }}</span>
            </span>
          </template>

          <template #[`item.status`]="{ value }">
            <StatusChip :value="value" />
          </template>
          <template #[`item.sm`]="{ value }">
            <span class="text-no-wrap">{{ makeRub(value) }}</span>
          </template>
        </v-data-table>
      </v-tab-item>

      <v-tab-item value="pending_payments">
        <v-data-table
          :mobile-breakpoint="100"
          class="bidlist-table"
          :headers="dataTables.pending_payments.headers"
          :items="pending_payments"
          item-key="num"
          sort-by="num"
          sort-desc
        >
          <template #[`item.num`]="{ value }">
            <span>№{{ value }}</span>
          </template>

          <template #[`item.ogrn`]="{ value, item }">
            <span>
              <span>{{ item.company_name }}</span>
              <br />
              <span class="font font--label-light font--color_light">ОГРН: {{ value }}</span>
            </span>
          </template>

          <template #item.account_opened_date="{ value }">
            <span>{{ new Date(value).toLocaleDateString() }}</span>
          </template>
        </v-data-table>
      </v-tab-item>

      <v-tab-item value="reports">
        <ListReports />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import StatusChip from "@/components/payment/StatusChip";
import DateFilter from "@/components/common/DateFilter";
import StatusFilter from "@/components/common/StatusFilter.vue";
import ActReports from "@/components/payment/ActReports.vue";
import ListReports from "@/components/payment/ListReports";

import debounce from "lodash/debounce";
import { required } from "@/utils/rules";
import { makeRub } from "@/mixins/makeRub";

export default {
  mixins: [makeRub],
  components: {
    ListReports,
    StatusChip,
    StatusFilter,
    DateFilter,
    ActReports,
  },
  props: {
    items: Array,
  },
  data() {
    return {
      tab: 'transactions',
      dataTables: {
        transactions: {
          footerProps: {
            itemsPerPageText: "Вознаграждений на странице:",
            itemsPerPageAllText: "Все",
            pageText: "{0}-{1} из {2}",
            itemsPerPageOptions: [5, 10, 15],
          },
          noDataText: "Список вознаграждений пуст",
          headers: [
            {
              text: "Дата",
              value: "dadd",
              sortable: false,
            },
            {
              text: "Наименование операции",
              value: "reason",
              sortable: false,
            },
            { text: "Статус", value: "status", sortable: false },
            { text: "Сумма", value: "sm", sortable: false },
          ],
        },
        pending_payments: {
          headers: [
            {
              text: "Заявка",
              value: "num",
              sortable: false,
            },
            {
              text: "Наименование клиента/ОГРН",
              value: "ogrn",
              sortable: false,
            },
            {
              text: "Дата открытия счёта",
              value: "account_opened_date",
              sortable: false
            }
          ]
        }
      },
      statusFilterPayment: false,
      rules: {
        required
      }
    }
  },

  computed: {
    ...mapState("billing", ["payments", "pending_payments", "total", "sum_refill", "sum_wo", "statuses", "payout_transactions"]),
    ...mapGetters("billing", ["hasStatusFilter", "dateFilter", "statusFilter"]),

    statusList() {
      return [
        {
          label: "Все статусы",
          value: "all",
        },
        // мапим статусы из store
        ...Object.entries(this.statuses).map(([value, item]) => ({ value, label: item.label })),
      ];
    },
    search_query: {
      get() {
        return this.$store.state.billing.search_query;
      },
      set(value) {
        this.setSearchQuery(value);
      },
    },

    options: {
      get() {
        return {
          page: this.$store.state.billing.page,
          itemsPerPage: this.$store.state.billing.pageSize,
        };
      },
      set({ page, itemsPerPage }) {
        this.setPage(page);
        this.setPageSize(itemsPerPage);
      },
    },

    hasPendingPayments() {
      return (this.pending_payments?.length ?? 0) > 0;
    },
  },

  watch: {
    search_query() {
      this.debouncedSearch();
    },

    options: {
      handler() {
        this.getPayments();
      },
      deep: true,
    },

    tab(current) {
      // обновляем инфу при переходе между вкладками
      //this.getBalance();
      if (current === 'transactions') {
        this.getPayments();
      } else if (current === 'reports') {
        this.getReportsList();
      }
    },
  },

  methods: {
    ...mapActions("billing", ["getPayments", "getBalance", "getReportsList"]),
    ...mapMutations("billing", ["setSearchQuery", "setDateFilter", "setStatusFilter"]),

    applyStatusFilter(status) {
      this.setStatusFilter(status);
      this.options = { page: 1, itemsPerPage: this.options.itemsPerPage };
      this.getPayments();
      this.closeStatusFilter();
    },

    closeStatusFilter() {
      this.statusFilterPayment = false;
    },

    shouldCloseFilter() {
      return this.statusFilterPayment;
    },
    ...mapMutations("billing", ["setPage", "setPageSize", "setSearchQuery", "setStatusFilter"]),

    applyDateFilter({ start, end }) {
      this.setDateFilter({ start, end });
      this.options = { page: 1, itemsPerPage: this.options.itemsPerPage };
      this.getPayments();
    },

    applyUserInputFilter() {
      this.options = { page: 1, itemsPerPage: this.options.itemsPerPage };
      this.getPayments();
    },
  },

  created() {
    this.debouncedSearch = debounce(this.applyUserInputFilter, 500);
  },
};
</script>

<style lang="scss">
.payments {
  &__stat {
    background-color: #f5f5f6;
    justify-content: center;
    border-radius: 4px;
  }
}
.payments-tab-link {
  text-transform: none;

  @media (max-width: 360px) {
    font-size: 14px;
  }
}
.theme--light.v-data-table.bidlist-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #777c87;
}

.v-data-table.bidlist-table > .v-data-table__wrapper > table > thead > tr > th {
  text-transform: uppercase;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.1em;
  font-weight: 400;
  height: auto;
  padding: 12px 16px;
}

.v-data-table.bidlist-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 16px;
}

.v-data-table-header {
  background-color: #f5f5f6;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(100%, 0);
}
</style>
